import React, {useEffect, useState} from 'react';
import {Utilisateur, getUtilisateurs, updateUtilisateurReferent} from '../../services/apiUtilisateurs';
import {DataTable} from '../../components/base/DataTable';
import Section from "../../components/base/Section";
import {Title} from "../../components/base/Title"
import { handleApiError } from 'utils/errorHandlers';
import { ApiLoading } from 'components/ApiLoading';
import { Dialog } from 'components/base/Dialog';
import { Switch } from 'components/base/Switch';
import { Button } from 'components/base/Button';

export const Utilisateurs: React.FC = () => {
	const [utilisateurs, setUtilisateurs] = useState<Utilisateur[]>([]);
	const [loading, setLoading] = useState(true);
	const [errors, setErrors] = useState<Record<string, string[]>>({});
	const [selectedUtilisateur, setSelectedUtilisateur] = useState<Utilisateur | null>(null);

	useEffect(() => {
		const fetchUtilisateurs = async () => {
			try {
				const data = await getUtilisateurs();
				setUtilisateurs(data);
			} catch (error: any) {
				setErrors(handleApiError(error));
			} finally {
				setLoading(false);
			}
		};

		fetchUtilisateurs();
	}, []);

  if (errors && errors.general) {
    return <ApiLoading type="error">{errors.general[0]}</ApiLoading>;
  }

  if (loading) {
    return <ApiLoading type="loading">Chargement des utilisateurs...</ApiLoading>;
  }

  if (utilisateurs.length === 0) {
    return <ApiLoading type="no-data">Aucun utilisateur trouvé</ApiLoading>;
  }

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();		
		const isReferent = selectedUtilisateur?.est_referent ?? false;
		try {
			const response = await updateUtilisateurReferent(selectedUtilisateur?.id ?? 0, 
				isReferent);

			if(response.status === 'success') {
				setUtilisateurs(utilisateurs.map(utilisateur => 
					utilisateur.id === selectedUtilisateur?.id ? 
					{...utilisateur, est_referent: isReferent} : utilisateur
				));
			}

		} catch (error) {
			console.error("Erreur lors de la mise à jour de l'utilisateur:", error);
		}
		setSelectedUtilisateur(null);
	}

	return (
		<Section fullwidth>
			<Title type="h2" className="mb-4">Listes des utilisateurs</Title>
			<DataTable
				columns={[
					{key: 'nom_complet', label: 'Nom',},
					{key: 'email', label: 'Email',},
					{key: 'telephone', label: 'Tél',},
					{key: 'groupe_name', label: 'Groupe',},
					{key: 'est_referent', label: 'Référent ?', render: (value) => value ? "Oui" : "Non"},
				]}
				data={utilisateurs}
				actions={[
					{label: 'Modifier', buttonVariant: "primary", onClick: (row) => setSelectedUtilisateur(row)},
				]}
				actionWidth='w-32'
			/>

			<Dialog
				open={selectedUtilisateur !== null}
				onClose={() => setSelectedUtilisateur(null)}
				title={`${selectedUtilisateur?.nom_complet}`}
				customBtn={true}
			>
				<form onSubmit={handleSubmit}>
					<Switch
						label={`Référent pour le groupe ${selectedUtilisateur?.groupe_name} ?`}
						checked={selectedUtilisateur?.est_referent ?? false}
						color='bg-primary'
						onChange={(checked) => {
							if (selectedUtilisateur) {
								setSelectedUtilisateur({...selectedUtilisateur, est_referent: checked});
							}
						}}
					/>

					<div className='flex justify-end gap-2 mt-6'>
						<Button variant='primary-outline' type="button" onClick={() => setSelectedUtilisateur(null)}>Annuler</Button>
						<Button variant='primary' type="submit">Confirmer</Button>
					</div>
				</form>
			</Dialog>
		</Section>
	);
};